import axios from 'axios'
import router from '../../router'
const state = {
  proList: [],
  proRtn: ''
}

const getters = {
  getProList (state) {
    return state.proList
  },
  getTranProRtn (state) {
    return state.proRtn
  }
}

const mutations = {
  setProList (state, payload) {
    state.proList = payload
  },
  setTranProRtn (state, payload) {
    state.proRtn = payload
  }
}

const actions = {
  apiProList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getProList', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setProList', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          // alert(error.response.data.message)
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranPro (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        axios.post('/api/admin/tranProList', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranProRtn', response.data.proId)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/expertmanagement.js